'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var magicFormBuilder = require('@gig/magic-form-builder');
var magicAccountTypes = require('@gig/magic-account-types');

var onCountryChange = function (fieldConfig) {
    return function (value, formState, setField) {
        var enabled = magicCommon.objectValueOrDefault(fieldConfig, value).enabled;
        setField({
            id: 'personalID',
            hidden: !enabled,
        });
    };
};
var fieldValidator = function (fieldConfig) {
    return function (personalId, formData) {
        var validation = magicCommon.objectValueOrDefault(fieldConfig, formData.country.value).validation;
        try {
            var validatorFn = magicAccountTypes.getPersonalIdValidator(validation);
            return validatorFn
                ? validatorFn(personalId, { date: formData.dob.value })
                : false;
        }
        catch (e) {
            return false;
        }
    };
};
function personalID(fieldConfig) {
    return {
        id: 'personalID',
        component: 'magic-ui-form-field',
        isDataField: true,
        type: 'text',
        testId: 'step2-personalID',
        validationDisplay: magicFormBuilder.ValidationDisplay.OnTouchShowMessage,
        properties: {
            placeholder: magicCommon.translate('sign-up-step-two.personal-id.placeholder'),
        },
        validation: [
            {
                name: 'required',
                fn: magicFormBuilder.required,
                message: magicCommon.translate('sign-up-step-two.personal-id.required-error'),
            },
            {
                name: 'is-valid-personal-id',
                fn: fieldValidator(fieldConfig),
                message: magicCommon.translate('sign-up-step-two.personal-id.error'),
                triggeringFields: ['country', 'dob'],
            },
        ],
        triggers: {
            country: onCountryChange(fieldConfig),
        },
        converter: function (formValue) {
            var personalId = formValue.personalID.value;
            return {
                userAdditionalFields: {
                    socialSecurityNumber: personalId
                        ? magicAccountTypes.getPersonalIdFormatter()(personalId)
                        : '',
                },
            };
        },
    };
}

exports.personalID = personalID;
